import Vue from 'vue'

export default Vue.extend({
  props: {
    href: {
      type: String,
      default: '',
    },
  },
  methods: {
    setLocale(locale: 'en' | 'de') {
      this.$store.dispatch('locale/set', { locale })
    },
  },
  computed: {
    availableLocales(): string[] {
      return this.$i18n.availableLocales.filter((locale) => locale !== this.currentLocale)
    },
    currentLocale(): string {
      return this.$i18n.locale
    },
  },
})
